// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1Z4Ho","header":"ReportDetails_header__yepnr","title":"ReportDetails_title__26fze","left":"ReportDetails_left__2cLRW"};